import React from 'react'

export const CircleGif = () => {
    return (
        <div className="preloader-wrapper big active sizeGifLoad" >
            <div className="spinner-layer spinner-white-only">
                <div className="circle-clipper left">
                    <div className="circle"></div>
                </div><div className="gap-patch">
                        <div className="circle"></div>
                    </div><div className="circle-clipper right">
                    <div className="circle"></div>
            </div>
        </div>
        </div>
    )
}
